import { RouteDescriptor } from "../../RouteDescriptor";
import { Route } from "../../Route";
import { ForOperatorsPage } from "../../../../../pages/General/ForOperators/ForOperatorsPage";
import { groupAll } from "../../../roles/groups";
import { defineMessage } from "react-intl";

const TitleMessage = defineMessage({
  id: "forOperatorsRoute.title",
  defaultMessage: "For Operators",
});

export const forOperators: RouteDescriptor<Route.forOperators> = {
  route: Route.forOperators,
  render: ForOperatorsPage,
  title: TitleMessage,
  path: "/for-operators",
  allowRoles: [...groupAll],
  redirectToHomeRoles: [],
  showInSidebar: false,
};
